import React from 'react';
import { Icon } from "@iconify/react/dist/iconify.js";
import { NavLink, useLocation } from "react-router-dom";
import './AdminNavigation.css';

const AdminNavigation = ({ userType }) => {
  // userType can be 'admin' or 'superuser'
  
  const isSuperUser = userType === 'superuser';
  const isAdmin = userType === 'admin';
  const isUser = userType === 'user';
  
  const location = useLocation();
  
  return (
    
    <>
      {isSuperUser | isAdmin && (
        
        <ul className="sidebar-menu" id="sidebar-menu">
          {/* Dashboard */}
          <li>
            <NavLink
              to='/admin-dashboard'
              className={(navData) => navData.isActive ? "active-page" : ""}
            >
              <Icon icon='solar:home-smile-angle-outline' className='menu-icon' />
              <span>Dashboard</span>
            </NavLink>
          </li>

          {/* Section Title */}
          <li className="sidebar-menu-title">License Management</li>

          {/* Customer Management */}
          <li>
            <NavLink
              to='/admin/customers'
              className={(navData) => location.pathname === '/admin/customers' || location.pathname === '/admin/customers/create' ? "active-page" : ""}
            >
              <Icon icon='mdi:domain' className='menu-icon' />
              <span>Customers</span>
            </NavLink>
          </li>

          {/* License Items */}
          <li>
            <NavLink
              to='/admin/licenses'
              className={(navData) => location.pathname === '/admin/licenses' || location.pathname === '/admin/licenses/create' ? "active-page" : ""}
            >
              <Icon icon='mdi:license' className='menu-icon' />
              <span>Licenses</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to='/admin/mac-requests'
              className={(navData) => navData.isActive ? "active-page" : ""}
            >
              <Icon icon='mdi:swap-horizontal' className='menu-icon' />
              <span>MAC Requests</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to='/admin/licenses/revoked'
              className={(navData) => navData.isActive ? "active-page" : ""}
            >
              <Icon icon='mdi:cancel' className='menu-icon' />
              <span>Revoked Licenses</span>
            </NavLink>
          </li>

          {/* Section Title */}
          <li className="sidebar-menu-title">Reports</li>

          {/* Report Items */}
          <li>
            <NavLink
              to='/admin/reports/license-expiry'
              className={(navData) => navData.isActive ? "active-page" : ""}
            >
              <Icon icon='mdi:calendar-clock' className='menu-icon' />
              <span>License Expiry</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to='/admin/reports/validation'
              className={(navData) => navData.isActive ? "active-page" : ""}
            >
              <Icon icon='mdi:alert-circle' className='menu-icon' />
              <span>Validation Failures</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to='/admin/reports/inactive'
              className={(navData) => navData.isActive ? "active-page" : ""}
            >
              <Icon icon='mdi:sleep' className='menu-icon' />
              <span>Inactive Licenses</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to='/admin/reports/analytics'
              className={(navData) => navData.isActive ? "active-page" : ""}
            >
              <Icon icon='mdi:chart-line' className='menu-icon' />
              <span>Usage Analytics</span>
            </NavLink>
          </li>

          {/* Super User Only Sections */}
          {isSuperUser && (
            <>
              {/* Section Title */}
              <li className="sidebar-menu-title">Administration</li>

              {/* User Management */}
              <li>
                <NavLink
                  to='/admin/users' 
                  className={(navData) => location.pathname === '/admin/users' || location.pathname === '/admin/users/add' || location.pathname.startsWith('/admin/users/edit/') ? "active-page" : ""}
                  end 
                  // className={(navData) => navData.isActive ? "active-page" : ""}
                >
                  <Icon icon='mdi:account-multiple' className='menu-icon' />
                  <span>Users</span>
                </NavLink>
              </li>

              <li>
                <NavLink
                  to='/admin/users/admins'
                  end 
                  className={(navData) => navData.isActive ? "active-page" : ""}
                >
                  <Icon icon='mdi:shield-account' className='menu-icon' />
                  <span>Admin Users</span>
                </NavLink>
              </li>

              {/* System Settings */}
              <li>
                <NavLink
                  to='/admin/settings/general'
                  className={(navData) => navData.isActive ? "active-page" : ""}
                >
                  <Icon icon='mdi:cog' className='menu-icon' />
                  <span>General Settings</span>
                </NavLink>
              </li>

              <li>
                <NavLink
                  to='/admin/settings/security'
                  className={(navData) => navData.isActive ? "active-page" : ""}
                >
                  <Icon icon='mdi:security' className='menu-icon' />
                  <span>Security Settings</span>
                </NavLink>
              </li>

              <li>
                <NavLink
                  to='/admin/settings/logs'
                  className={(navData) => navData.isActive ? "active-page" : ""}
                >
                  <Icon icon='mdi:text-box-search' className='menu-icon' />
                  <span>System Logs</span>
                </NavLink>
              </li>

              <li>
                <NavLink
                  to='/admin/terms'
                  className={(navData) => navData.isActive ? "active-page" : ""}
                >
                  <Icon icon='mdi:file-document-edit-outline' className='menu-icon' />
                  <span>Terms & Conditions</span>
                </NavLink>
              </li>
            </>
          )}
        </ul>
        
      )}
      {isUser && (
        <ul className="sidebar-menu" id="sidebar-menu">
          {/* Dashboard */}
          <li>
            <NavLink
              to='/user-dashboard'
              className={(navData) => navData.isActive ? "active-page" : ""}
            >
              <Icon icon='solar:home-smile-angle-outline' className='menu-icon' />
              <span>Dashboard</span>
            </NavLink>
          </li>
        </ul>
      )}


    </>



  );
};

export default AdminNavigation;
